"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBounds = void 0;
const getBounds = ({ data, key, }) => {
    if (!data || data.length === 0) {
        return [0, 100]; // Default bounds
    }
    const bounds = data.reduce((acc, row) => {
        if (row[key] < acc.lowerBound)
            acc.lowerBound = row[key];
        if (row[key] > acc.upperBound)
            acc.upperBound = row[key];
        return acc;
    }, { lowerBound: data[0][key], upperBound: data[0][key] });
    return [bounds.lowerBound, bounds.upperBound];
};
exports.getBounds = getBounds;
